<template>
  <div class="home mt-2">
    <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
      <div class="d-flex align-items-center flex-wrap">
        <h2 class="mb-0 mr-3">Billing Codes</h2>
      </div>

      <div class="d-flex align-items-center flex-wrap mt-2 mt-sm-0">
        <button
          class="btn btn-sm btn-principal mr-2"
          data-toggle="collapse"
          href="#filtroscollapse"
          role="button"
          aria-expanded="false"
          aria-controls="filtroscollapse"
        >
          <i class="bi-filter"></i> Filtros
        </button>
        <button
          class="btn btn-sm btn-principal mr-2"
          @click="getBillingCodesExcel"
          title="Descargar listado completo"
        >
          <i class="bi-download"></i> Descargar listado completo
        </button>
        <button
          class="btn btn-sm btn-principal"
          data-toggle="tooltip"
          data-placement="top"
          title="Nuevo Billing Code"
          @click="showEdit({}, 'add')"
        >
          <i class="bi-plus"></i> Nuevo Billing Code
        </button>
      </div>
    </div>
    <div class="collapse mb-3" id="filtroscollapse">
      <div class="card card-body bg-light border-0 shadow-sm py-3 px-4">
        <div class="form-row align-items-end">
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="criterio_cod_tas">Por Código TAS</label>
            <input type="text" class="form-control" id="criterio_cod_tas" v-model="criterio.cod_tas" placeholder="Código TAS..." @keyup.enter="billingCodesBuscar()" aria-label="Código TAS" />
          </div>
          <div class="form-group col mb-2">
            <label class="font-weight-bold small text-muted mb-1" for="criterio_descripcion">Por Descripción</label>
            <input type="text" class="form-control" id="criterio_descripcion" v-model="criterio.descripcion" placeholder="Descripción..." @keyup.enter="billingCodesBuscar()" aria-label="Descripción" />
          </div>
          <div class="form-group col-auto mb-2">
            <button @click="billingCodesBuscar()" class="btn btn-info px-4"><i class="bi-search"></i> Buscar</button>
          </div>
        </div>
      </div>
    </div>
    <div class="alert alert-success" role="alert" v-if="success">{{ success }}</div>
    <div class="alert alert-danger" role="alert" v-if="error">{{ error }}</div>
    <data-table
      v-if="billingCodesBusqueda && billingCodesBusqueda.data && billingCodesBusqueda.data.length"
      :columns="columns"
      :data="billingCodesBusqueda.data"
      :order-by-field="orderByField"
      :order-by-direction="orderByDirection"
      id-key="id_billing_code"
      :show-actions="isAdmin()"
      actions-width="110"
      @sort="orderByfield"
    >
      <template #actions="{ item }">
        <table-actions
          :item="item"
          active-key="activo"
          @edit="showEdit(item, 'edit')"
          @toggle="showEdit(item, 'toggle')"
        />
      </template>
    </data-table>
    <Paginador v-if="billingCodesBusqueda && billingCodesBusqueda.pages" :pages="billingCodesBusqueda.pages" @selPage="changePage"></Paginador>
    <empty-state
      :show="Boolean(post && !(billingCodesBusqueda && billingCodesBusqueda.data && billingCodesBusqueda.data.length))"
      message="No se encontraron billing codes con el criterio seleccionado."
    />
    <div v-if="error">{{ error.message }}</div>
    <!-- Modal -->
    <div v-if="showModal">
      <transition name="modal">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable"
                role="document"
                :class="operation == 'jerarquia' ? 'modal-lg modal-dialog-scrollable' : ''"
            >
              <div class="modal-content">
                <div class="modal-header">
                  <h5 v-if="operation == 'edit'"   class="modal-title">Editar Billing Code {{ editData.id_billing_code }}</h5>
                  <h5 v-if="operation == 'add'"    class="modal-title">Nuevo Billing Code</h5>
                    <h5 v-if="operation == 'toggle'" class="modal-title">
                    <span v-if="editData.activo == 1"> Suspender Billing Code</span>
                    <span v-if="editData.activo == 0"> Reactivar Billing Code</span>
                  </h5>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <form v-if="operation == 'delete' ||
                              operation == 'edit' ||
                              operation == 'add'"
                  >
                    



                    <div class="form-group">
                      <label>Código TAS</label>
                      <b class="form-control" readonly v-if="operation == 'delete'">
                        {{ editData.cod_tas }}
                      </b>
                      <input class="form-control" v-if="operation == 'edit' || operation == 'add'" type="text" placeholder="Ej: TAS01" v-model="editData.cod_tas" />
                      <small class="form-text text-muted">Código TAS identificador del billing code (ej: TAS01).</small>
                    </div>

                    <div class="form-group">
                      <label>Precio Sin Impuesto</label>
                      <b class="form-control" readonly v-if="operation == 'delete'">
                        {{ editData.precio_sin_imp }}
                      </b>
                      <input class="form-control" v-if="operation == 'edit' || operation == 'add'" type="text" placeholder="Ej: 10.00" v-model="editData.precio_sin_imp" />
                      <small class="form-text text-muted">Valor monetario sin impuestos (número decimal, ej: 10.00 o 10).</small>
                    </div>

                    <div class="form-group">
                      <label>Precio Con Impuesto</label>
                      <b class="form-control" readonly v-if="operation == 'delete'">
                        {{ editData.precio_con_imp }}
                      </b>
                      <input class="form-control" v-if="operation == 'edit' || operation == 'add'" type="text" placeholder="Ej: 11.80" v-model="editData.precio_con_imp" />
                      <small class="form-text text-muted">Valor monetario con impuestos incluidos (número decimal, ej: 11.80 o 11).</small>
                    </div>

                    <div class="form-group">
                      <label>Descripción</label>
                      <textarea class="form-control" v-if="operation == 'edit' || operation == 'add'" placeholder="Ej: Cobro diario suscripción" v-model="editData.descripcion" />
                      <small class="form-text text-muted">Nombre o descripción representativa del billing code.</small>
                    </div>

                    <div v-if="errors" class="alert alert-danger" role="alert">
                      <i class="bi bi-exclamation-triangle me-1"></i>
                      {{ typeof errors === 'object' ? (errors.error || errors.message || JSON.stringify(errors)) : errors }}
                    </div>
                  </form>
                    <p v-if="operation == 'toggle'">
                    Esta seguto de realizár esta acción?
                  </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="closeModal">
                      <span v-if="operation == 'jerarquia'">Cerrar</span>
                      <span v-else>Cancelar</span>
                    </button>
   
                  <button
                    type="button"
                    v-if="operation == 'toggle'"
                    @click="toggleStatus"
                    class="btn btn-primary"
                  >
                    <span v-if="editData.activo == 1"> Suspender</span>
                    <span v-if="editData.activo == 0"> Reactivar</span>
                  </button>
                    <button type="button" v-if="operation == 'edit'" @click="editBillingCode" class="btn btn-primary">Guardar</button>
                    <button type="button" v-if="operation == 'add'" @click="agregarBillingCode" class="btn btn-primary">Guardar</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>

</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Paginador from "./Paginador.vue";
import DataTable from "./utiles/DataTable.vue";
import TableActions from "./utiles/TableActions.vue";
import EmptyState from "./utiles/EmptyState.vue";
import { tableSortMixin } from "@/mixins/tableSortMixin";
import { startAsyncExport } from "@/utils/exportHelper";

export default {
  name: "BillingCodes",
  mixins: [tableSortMixin],

  data() {
    return {
      columns: [
        { label: "Id", field: "id_billing_code", width: "80" },
        { label: "Código TAS", field: "cod_tas" },
        { label: "Precio Sin Imp", field: "precio_sin_imp" },
        { label: "Precio Con Imp", field: "precio_con_imp" },
        { label: "Descripción", field: "descripcion" },
        { label: "Estado", field: "activo", type: "badge", width: "110" },
      ],
      success: null,
      error: null,
      criterio: {
        cod_tas: null,
        descripcion: null,
        id_integrador: localStorage.getItem('integrador'),
      },
      billingCodesBusqueda: null,
      post: false,
      showModal: false,
      editData: null,
      operation: null,
      page: 1,
      errors: [],
      pages: null
    };
  },

  components: {
    DataTable,
    Paginador,
    TableActions,
    EmptyState,
  },

  created() {
    this.orderByField = "id_billing_code";
    this.getBillingCodesBusqueda();
  },

  computed: {
    ...mapGetters("auth", ["user"])
  },

  methods: {
    billingCodesBuscar: function() {
      this.changePage(1);
    },

    changePage: function(page) {
      this.page = page;
      this.getBillingCodesBusqueda(false);
    },

    orderByfield: function(field) {
      this.toggleOrder(field);
      this.getBillingCodesBusqueda(false);
    },

    getBillingCodesBusqueda: function(hideResult = true) {
      if (hideResult) this.billingCodesBusqueda = null;
      this.post = false;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/busqueda", {
          page: this.page,
          id_integrador: this.criterio.id_integrador,
          cod_tas: this.criterio.cod_tas,
          descripcion: this.criterio.descripcion,
          order_by: { field: this.orderByField, order: this.orderByDirection }
        })
        .then(response => {
          this.billingCodesBusqueda = response.data;
        })
        .catch(e => {
          this.errors.push(e);
           if (e.response.status==429) {
          Swal.fire({
            title: "Error!",
            text: "Espere un momento y vuelva a intentarlo.",
            icon: "error",
            confirmButtonText: "Aceptar",
          });
          }else{
          Swal.fire({
            title: "Error!",
            text: "Ha ocurrido un error al buscar los códigos de facturación",
            icon: "error",
            confirmButtonText: "Aceptar"
          });}
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          this.post = true;
        });
    },

    deleteBillingCode: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/delete", {
          id_billing_code: this.editData.id_billing_code
        })
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar eliminar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
toggleStatus: function () {
      this.errors = null;
      this.$store.commit("setLoading", true);
      this.editData.activo = 1 - this.editData.activo;
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/update", this.editData)
        .then((response) => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "Billingcode actualizada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch((e) => {
          if (e.response && e.response.data && e.response.data.error) {
            this.errors = e.response.data.error;
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
    editBillingCode: function() {
      this.errors = null;
      this.$store.commit("setLoading", true);

      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/update", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "BillingCode actualizado correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          const resData = e.response && e.response.data;
          if (resData) {
            let errorMsg = resData.error || "Ha ocurrido un error al intentar guardar";
            if (resData.errors && typeof resData.errors === "object" && Object.keys(resData.errors).length > 0) {
              const details = Object.entries(resData.errors)
                .map(([field, errs]) => `${field}: ${Array.isArray(errs) ? errs.join(", ") : errs}`)
                .join(" | ");
              errorMsg += ` (${details})`;
            }
            this.errors = errorMsg;
            Swal.fire({
              title: "Error!",
              text: errorMsg,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },
      isAdmin() {
      return this.user && this.user.rol == "admin";
    },  
    showEdit: function(item, operation) {
      this.errors = null;
      this.editData = Object.assign({}, item);
      if (operation === 'add') {
        this.editData = {
          cod_tas: "",
          descripcion: "",
          precio_sin_imp: "",
          precio_con_imp: "",
          activo: 1,
        };
      }
      this.showModal = true;
      this.operation = operation;
    },

    getBillingCodesExcel: function () {
      startAsyncExport("billingcode", {
        id_integrador: this.criterio.id_integrador,
        order_by: {
          field: this.orderByField,
          order: this.orderByDirection,
        },
      }, "BillingCodes");
    },

    agregarBillingCode: function() {
      this.errors = null;
      this.editData.id_integrador = this.criterio.id_integrador;
      this.$store.commit("setLoading", true);
      axios
        .post(process.env.VUE_APP_API_URL + "billingcode/new", this.editData)
        .then(response => {
          if (
            response &&
            response.data &&
            response.data.errno &&
            response.data.errno > 0
          ) {
            this.errors = response.data.error;
          } else {
            Swal.fire({
              title: "Bien!",
              text: "BillingCode creada correctamente",
              icon: "success",
              confirmButtonText: "Aceptar",
            });
            this.showModal = false;
            this.operation = null;
            this.editData = null;
          }
        })
        .catch(e => {
          const resData = e.response && e.response.data;
          if (resData) {
            let errorMsg = resData.error || "Ha ocurrido un error al intentar guardar";
            if (resData.errors && typeof resData.errors === "object" && Object.keys(resData.errors).length > 0) {
              const details = Object.entries(resData.errors)
                .map(([field, errs]) => `${field}: ${Array.isArray(errs) ? errs.join(", ") : errs}`)
                .join(" | ");
              errorMsg += ` (${details})`;
            }
            this.errors = errorMsg;
            Swal.fire({
              title: "Error!",
              text: errorMsg,
              icon: "error",
              confirmButtonText: "Aceptar",
            });
          } else {
            Swal.fire({
              title: "Error!",
              text: "Ha ocurrido un error al intentar guardar",
              icon: "error",
              confirmButtonText: "Aceptar"
            });
          }
        })
        .finally(() => {
          this.$store.commit("setLoading", false);
          if (this.operation == null) this.getBillingCodesBusqueda();
        });
    },

    closeModal() {
      this.showModal = false;
      this.operation = null;
    }
  }
};
</script>

<style scoped></style>
